import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        navigate("/admin", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/admin", { replace: true }));
  }, [navigate, setUser]);

  return null;
}
